import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRightOutlined } from "@ant-design/icons";
import {
    FaBullhorn,
    FaCode,
    FaEdit,
    FaMobileAlt,
    FaVideo,
} from "react-icons/fa";

type SolutionItem = {
    id: string;
    name: string;
    description: string;
    path: string;
    icon: React.ReactNode;
};

const solutions: SolutionItem[] = [
    {
        id: "website-development",
        name: "Website Development",
        description: "Build modern websites and customer portals.",
        path: "/solutions/website-development",
        icon: <FaCode />,
    },
    {
        id: "mobile-app-development",
        name: "Mobile App Development",
        description: "Create high-performance Android and iOS applications.",
        path: "/solutions/mobile-app-development",
        icon: <FaMobileAlt />,
    },
    {
        id: "digital-marketing",
        name: "Digital Marketing",
        description: "Drive traffic, leads, and customer growth.",
        path: "/solutions/digital-marketing",
        icon: <FaBullhorn />,
    },
    {
        id: "video-editing",
        name: "Video Editing",
        description: "Produce polished videos for social and marketing channels.",
        path: "/solutions/video-editing",
        icon: <FaVideo />,
    },
    {
        id: "post-editing",
        name: "Post Editing",
        description: "Refine social content for stronger brand engagement.",
        path: "/solutions/post-editing",
        icon: <FaEdit />,
    },
];

export const SolutionsGrid = () => {
    const navigate = useNavigate();

    return (
        <div className="solutions-grid">
            {solutions.map((solution) => (
                <button
                    key={solution.id}
                    type="button"
                    className="solutions-grid-card"
                    onClick={() => navigate(solution.path)}
                >
                    <span className="solutions-grid-card__icon">{solution.icon}</span>
                    <div className="solutions-grid-card__body">
                        <div className="solutions-grid-card__header">
                            <span className="solutions-grid-card__title">{solution.name}</span>
                            <ArrowRightOutlined className="solutions-grid-card__arrow" aria-hidden="true" />
                        </div>
                        <p className="solutions-grid-card__desc">{solution.description}</p>
                    </div>
                </button>
            ))}
        </div>
    );
};
